"use client";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api/api";
import {
  MS_10_MINUTES,
  MS_5_MINUTES,
  useWorkplaceRequestsAllowed
} from "@gettactic/hooks";

export function useWorkplaceRequestsByReservation(
  reservationId: string | undefined,
  options: {
    enabled?: boolean;
  } = {}
) {
  const isWorkplaceRequestsAllowed =
    useWorkplaceRequestsAllowed("workplace_requests");
  const { data, error, refetch, isFetching, status } = useQuery({
    queryKey: ["workplaceRequestsBySchedule", reservationId],

    queryFn: async () => {
      if (!reservationId) {
        throw new Error("Schedule ID is required");
      }

      const res =
        await api.client.workplaceRequests.getWorkplaceRequestsBySchedule(
          reservationId
        );
      return res.result;
    },

    enabled:
      isWorkplaceRequestsAllowed &&
      !!reservationId &&
      options.enabled !== false,

    // 5 minutes
    staleTime: MS_5_MINUTES
  });

  return {
    data,
    error,
    refetch,
    isFetching,
    status,
    allElements: data ?? [],
    totalElements: (data || [])?.length ?? 0
  };
}
